module.exports = __webpack_public_path__ + "spine/pig.json?d14efabd08f551f926df8ace0961c536";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/pig/pig.json
// module id = 1744
// module chunks = 3